module.exports = __webpack_public_path__ + "static/media/safari.93d337fb.svg";